<div *ngIf="(loading$ | async) && !(all_loaded$ | async); else loaded">
    <mat-spinner></mat-spinner>
</div>

<ng-template #loaded>
    <ng-oct-report></ng-oct-report>
</ng-template>